module.exports = __webpack_public_path__ + "static/media/cover-3.6f4d2f7b.jpg";